import React from 'react';
import { Button, Form, Offcanvas } from "react-bootstrap";
import MultiSelect from '../../components/MultiSelect';
import SearchSelect from '../../components/SearchSelect';

const TicketFilter = ({ show, close }) => {
    return (
        <>
            <Offcanvas show={show} onHide={close} placement="end">
                <Offcanvas.Header closeButton>
                    <Offcanvas.Title>
                        Ticket Filter
                    </Offcanvas.Title>
                </Offcanvas.Header>
                <Offcanvas.Body>
                    <Form>
                        <Form.Group className="mb-3">
                            <Form.Label>League:</Form.Label>
                            {/* <Form.Select>
                                <option value="">League 1</option>
                                <option value="">League 2</option>
                                <option value="">League 3</option>
                            </Form.Select> */}
                            <SearchSelect
                                options={
                                    [
                                        { value: 'League 1', label: 'League 1' },
                                        { value: 'League 2', label: 'League 2' },
                                        { value: 'League 3', label: 'League 3' }
                                    ]
                                }
                                placeholder={"Search by Lead"}
                            />
                        </Form.Group>

                        <Form.Group className="mb-3">
                            <Form.Label>Team:</Form.Label>
                            {/* <Form.Control type="text" placeholder="Search by Team" /> */}
                            <SearchSelect
                                options={
                                    [
                                        { value: 'Team 1', label: 'Team 1' },
                                        { value: 'Team 2', label: 'Team 2' },
                                        { value: 'Team 3', label: 'Team 3' }
                                    ]
                                }
                                placeholder={"Search by Team"}
                            />
                        </Form.Group>
                        <Form.Group className="mb-3">
                            <Form.Label>Name:</Form.Label>
                            <Form.Control type="text" placeholder="Search by Name" />
                        </Form.Group>
                        <Form.Group className="mb-3">
                            <Form.Label>Email:</Form.Label>
                            <Form.Control type="text" placeholder="Search by Email" />
                        </Form.Group>
                        <Form.Group className="mb-3">
                            <Form.Label>Season Ticket Year:</Form.Label>
                            <Form.Control type="text" placeholder="Search by Season Ticket Year" />
                        </Form.Group>
                        <Form.Group className="mb-3">
                            <Form.Label>POD:</Form.Label>
                            <Form.Control type="text" placeholder="Search by POD" />
                        </Form.Group>
                        <Form.Group className="mb-3">
                            <Form.Label>Paid:</Form.Label>
                            <Form.Select>
                                <option value="">Paid</option>
                                <option value="">Unpaid</option>
                            </Form.Select>
                        </Form.Group>

                    </Form>
                </Offcanvas.Body>
                <Offcanvas.Header>
                    <div className="col-6">
                        <Button variant="primary" className="text-white w-100 fw-bold">
                            Reset
                        </Button>
                    </div>
                    <div className="col-6">
                        <Button variant="primary" onClick={close} className="text-white w-100 fw-bold">
                            Filter
                        </Button>
                    </div>
                </Offcanvas.Header>
            </Offcanvas>
        </>
    );
};

export default TicketFilter;